import React from "react";

export default function RestlessBodyContentSubstr(cellContent) {
  const body = cellContent;
  if (body) {
    return <div>{body.substr(0,200)}</div>;
  }
}
